import { Button, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';

import SharePointExplorer from './sharePointExplorer/SharePointExplorer';

const Document = ({ row, onCancelChanges }) => (
  <div style={{ minHeight: '700px', display: 'flex', flexDirection: 'column' }}>
    <DialogTitle id="form-dialog-title">SharePoint documents for {row?.FullyQualifiedName}</DialogTitle>
    <DialogContent style={{ flex: 1 }}>
      <SharePointExplorer customerId={row?.Id || row?._id} customerName={row?.FullyQualifiedName} />
    </DialogContent>
    <DialogActions style={{ padding: '0 23px 16px 0' }}>
      <Button onClick={onCancelChanges} color="secondary" variant="outlined" style={{ marginTop: '1rem' }}>
        Close
      </Button>
    </DialogActions>
  </div>
);

export default Document;

Document.propTypes = {
  onCancelChanges: PropTypes.func,
  row: PropTypes.shape({
    FullyQualifiedName: PropTypes.string,
    Id: PropTypes.string,
    _id: PropTypes.string
  })
};
